// extracted by mini-css-extract-plugin
module.exports = {"entranceIcon":"CartEntry_entranceIcon__yINgy","count":"CartEntry_count__PdgvI"};